export function AddCircle(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 4C12.6627 4 13.2 4.53726 13.2 5.2V10.8H18.8C19.4627 10.8 20 11.3373 20 12C20 12.6627 19.4627 13.2 18.8 13.2H13.2V18.8C13.2 19.4627 12.6627 20 12 20C11.3373 20 10.8 19.4627 10.8 18.8V13.2H5.2C4.53726 13.2 4 12.6627 4 12C4 11.3373 4.53726 10.8 5.2 10.8H10.8V5.2C10.8 4.53726 11.3373 4 12 4Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
